// extracted by mini-css-extract-plugin
export var locationCard = "_ic-0";